import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import KernteamNavbar from './navbar/KernteamNavbar';
import './KernteamLayout.css';

// Merkt sich für die Lebensdauer der Sitzung (bis zum Reload), ob die
// Einstiegs-Animationen bereits einmal gespielt wurden. Gewollt: Beim ersten
// Laden darf kurz animiert werden, danach ist jede Navigation animationsfrei.
let introAlreadyPlayed = false;

function KernteamLayout({ children }) {
  const location = useLocation();
  const [transitionKey, setTransitionKey] = useState(0);
  const [transitionActive, setTransitionActive] = useState(false);

  // true nur für die allererste Seite der Sitzung; jede weitere Layout-Instanz
  // (= jede weitere Seite) startet ohne Animationen.
  const animateIntroRef = useRef(!introAlreadyPlayed);
  const animateIntro = animateIntroRef.current;

  useEffect(() => {
    introAlreadyPlayed = true;
  }, []);

  useEffect(() => {
    setTransitionKey((prev) => prev + 1);

    // Farb-Sweep nur ein einziges Mal pro Sitzung und nur beim Einstieg aus
    // dem Portal (die Bereichs-Karten setzen fromPortal).
    const fromPortal = Boolean(location.state && location.state.fromPortal);
    if (!animateIntro || !fromPortal) return;

    setTransitionActive(true);
    const timeout = setTimeout(() => setTransitionActive(false), 1200);
    return () => clearTimeout(timeout);
  }, [location, animateIntro]);

  return (
    <>
      <KernteamNavbar />
      <div
        className={`page-transition ${transitionActive ? 'active' : ''}`}
        aria-hidden="true"
      />
      <div
        className={`kernteam-layout-content${animateIntro ? '' : ' no-intro'}`}
        key={`content-${transitionKey}`}
      >
        {children}
      </div>
    </>
  );
}

export default KernteamLayout;
